export const socketEventGenerateFont = 'generate-font-event';
export const socketEventRegisterUser = 'register-user-event';
